import { isValid } from 'date-fns';

export function calculateHotelNights(
  checkInDate: string,
  checkOutDate: string,
) {
  const checkIn = new Date(checkInDate);
  const checkOut = new Date(checkOutDate);
  const validDates = isValid(checkIn) && isValid(checkOut);

  if (validDates && checkIn <= checkOut) {
    const timeDifference = checkOut.getTime() - checkIn.getTime();
    const daysDifference = Math.ceil(timeDifference / (1000 * 3600 * 24));

    return daysDifference;
  } else {
    return 0;
  }
}
